export default __webpack_public_path__ + "static/media/instagram-logo.dde8fe80.svg";